import { Button, Spin } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { FormItem } from '../FormItem';
import { LoadingOutlined } from '@ant-design/icons';

interface ButtonI {
  label?: string;
  onClick?: any;
  type?: any;
  htmlType?: 'button' | 'submit' | 'reset';
  size?: SizeType;
  bg?: string;
  color?: string;
  loading?: boolean;
}

const CustomButton = ({
  type = 'primary',
  label,
  onClick,
  htmlType = 'button',
  size = 'large',
  bg = 'black',
  color,
  loading = false,
}: ButtonI) => {
  return (
    <FormItem>
      <Button
        type={type}
        onClick={onClick}
        htmlType={htmlType}
        style={{
          width: '100%',
          background: bg,
          color: color,
        }}
        size={size}
        disabled={loading}
      >
        {loading ? (
          <div>
            <Spin indicator={<LoadingOutlined style={{ fontSize: 20, color: '#fff' }} spin />} />
          </div>
        ) : (
          label
        )}
      </Button>
    </FormItem>
  );
};
export default CustomButton;
